import React, { memo, useRef, useEffect, useState } from "react"

import { Box, Stack } from "@mos-cat/ds"
import { Button } from "@dit/core-frontend"
import { ZoneCard } from "."

export const ZoneCardsTable = memo(
  ({
    data,
    isFetching,
    hasNextPage,
    fetchNextPage,
    infiniteCount = 1,
    isDisableFetch,
    updateResponseData,
    isMobileView,
    isRowView,
  }) => {
    const fetchRef = useRef(null)
    const [fetchCount, setFetchCount] = useState(0)

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && hasNextPage && !isFetching) {
            if (fetchCount < infiniteCount) {
              fetchNextPage()
              setFetchCount((prev) => prev + 1)
            }
          }
        },
        { threshold: 1.0 },
      )

      const currentRef = fetchRef.current
      if (currentRef) {
        observer.observe(currentRef)
      }

      return () => {
        if (currentRef) {
          observer.unobserve(currentRef)
        }
      }
    }, [fetchNextPage, hasNextPage, isFetching, fetchCount, infiniteCount])

    return (
      <Stack space="10px" position="relative">
        <Box
          display={isRowView && !isMobileView ? "flex" : "grid"}
          overflow={isRowView && !isMobileView ? "auto" : "hidden"}
          gridTemplateColumns={`repeat(auto-fill, ${isMobileView ? "48%" : "306px"})`}
          gridGap="16px"
          width="100%"
          position="relative"
        >
          {data?.items.map((zone) => (
            <ZoneCard
              key={`home-zones-card-${zone.id}`}
              zone={zone}
              updateResponseData={updateResponseData}
            />
          ))}
        </Box>
        {!isDisableFetch && <Box ref={fetchRef} />}
        {!isDisableFetch && hasNextPage && (
          <Button
            kind="borderless"
            onClick={fetchNextPage}
            vertSize="48"
            disabled={isFetching}
            loading={isFetching}
            loadingMessage="Загружаем проекты..."
            styles={{
              "& > *": {
                justifyContent: "center",
              },
            }}
          >
            Показать еще
          </Button>
        )}
      </Stack>
    )
  },
)

ZoneCardsTable.displayName = "ZoneCardsTable"
